import axios, { AxiosResponse } from "axios";
import AuthencticationResponse from "@/models/api/user/AuthenticationResponse"
import SelectListItem from '@/models/SelectListItem';

class Service {

    public async GetGroups(): Promise<AxiosResponse<SelectListItem[]>> {
        return axios.get('api/user/GetGroups');
    }

    public async GetAssociationUsers(token: string): Promise<AxiosResponse<any>> {
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };
        return axios.get('api/user/GetAssociationUsers', config);
    }

    public async SetAssociationUser(data: any, token: string): Promise<AxiosResponse<any>> {
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };
        return axios.post('api/user/SetAssociationUser', data, config);
    }

    public async Login(data: any): Promise<AxiosResponse<AuthencticationResponse>> {
        return axios.post('api/user/', data);
    }

    public async RegisterAdmin(data: any): Promise<AxiosResponse<string>> {
        return axios.post('api/user/RegisterAdmin', data);
    }

    public async RegisterUser(data: any): Promise<AxiosResponse<string>> {
        return axios.post('api/user/RegisterUser', data);
    }

    public async DeleteUser(id: string): Promise<AxiosResponse<string>> {
        return axios.delete(`api/user/${id}`);
    }

    public async GetRegisterRoles(): Promise<AxiosResponse<[]>> {
        return axios.get('api/user/GetRegisterRoles');
    }

    public async HasPassword(email: string): Promise<AxiosResponse<[]>> {
        return axios.get(`api/user/HasPassword/?email=${email}`);
    }

    public async GetAssociationUsersByEmail(email: string): Promise<AxiosResponse<[]>> {
        return axios.get(`api/user/GetAssociationUsersByEmail/?email=${email}`);
    }
    
    public async GetUsers(): Promise<AxiosResponse<[]>> {
        return axios.get('api/user/');
    }

    public async GetUsersPaged(data: any): Promise<AxiosResponse<any>> {
        return axios.post('api/user/GetUsersPaged', data);
    }

    public async GetAdminsPaged(data: any): Promise<AxiosResponse<any>> {
        return axios.post('api/user/GetAdminsPaged', data);
    }


    public async SendConfirmEmail(data: any): Promise<AxiosResponse<any>> {
        return axios.post('api/user/SendConfirmEmail', data);
    }

    public async ChangePassword(data: any): Promise<AxiosResponse<any>> {
        return axios.post('api/user/ChangePassword', data);
    }

    public async SendResetPassword(data: any): Promise<AxiosResponse<any>> {
        return axios.post('api/user/SendResetPassword', data);
    }
    
    // Used to confirm email and update password
    public async ConfirmUser(data: any): Promise<AxiosResponse<any>> {
        return axios.post('api/user/ConfirmUser', data);
    }

}

export const UserService: Service = new Service();
